module.exports = __webpack_public_path__ + "static/img/25.3ebc6f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/25.png
// module id = 197
// module chunks = 1